import { useState } from "react";
import { Stack, Typography, IconButton, Collapse, Box, Paper } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface CollapsibleSectionProps {
    title: string;
    children: React.ReactNode;
    defaultExpanded?: boolean;
}

export function CollapsibleSection({ title, children, defaultExpanded = true }: CollapsibleSectionProps) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
                onClick={() => setExpanded(!expanded)}
                sx={{
                    cursor: 'pointer',
                    userSelect: 'none',
                    p: 2,
                    transition: 'background-color 0.15s ease',
                    '&:hover': {
                        bgcolor: 'action.hover'
                    }
                }}
            >
                <Typography variant="subtitle1" fontWeight="bold" color="primary">
                    {title}
                </Typography>
                <IconButton size="small" onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
                    {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            </Stack>
            <Collapse in={expanded}>
                <Box sx={{ px: 2, pb: 2 }}>
                    {children}
                </Box>
            </Collapse>
        </Paper>
    );
}
